import React from 'react';
//material
import {withStyles} from '@material-ui/core';
//styles
import styles from './page-heading-styles';

const PageHeadingView = (props) => {
  const {classes, heading, subheading} = props;

  return (
    <div className={classes.container}>
      <div className={classes.heading}>
        {heading}
      </div>

      {
        subheading &&
          <div className={classes.subheading}>
            {subheading}
          </div>
      }
    </div>
  );
};

export default withStyles(styles) (PageHeadingView);
